const menu = {
    button: {
        open: document.querySelector(".nav-mobile__button"),
        close: document.querySelector(".nav-mobile__close"),
    },
    class: "nav-mobile__active",
    overlay: document.querySelector(".nav-mobile__overlay"),
    nav: document.querySelector(".nav-mobile"),
    dropDowns: document.querySelectorAll(".nav__item--drop"),
};

export function closeMenu() {
    menu.nav.classList.remove(menu.class);
    menu.overlay.removeAttribute("style");
    document.body.removeAttribute("style");
}

export function openMenu() {
    menu.nav.classList.add(menu.class);
    menu.overlay.style.left = 0;
    document.body.style.overflow = "hidden";
}

export function openSubMenu(event) {
    if (window.innerWidth < 992) {
        const clickedLink = event.target.closest(".nav__link");
        if (clickedLink && clickedLink.querySelector(".fa-chevron-down")) {
            event.preventDefault();
        }

        const dropdownItem = this;

        menu.dropDowns.forEach((item) => {
            if (item !== dropdownItem) {
                item.classList.remove("is-open");
            }
        });

        dropdownItem.classList.toggle("is-open");
    }
}

export default menu;
